<template>
  <div class="form-div">
     <div><Checkbox v-model="isCheck" @on-change="changeCheck">志愿者信息</Checkbox></div>
     <Form v-show="isCheck" class="isForm" label-position="right" :label-width="120">
       <FormItem class="isNoWidth">
              <span slot="label">编号:</span>
              <Input placeholder="请输入您的编号" v-model="formDataVolun.volunteerNo" />
        </FormItem>
       <FormItem class="isNoWidth">
             <span slot="label">加入时间:</span>
              <DatePicker type="date" v-model="formDataVolun.joinDate"></DatePicker>
        </FormItem>
       <FormItem class="isNoWidth">
             <span slot="label">分类:</span>
              <Select clearable v-model="formDataVolun.volunteerType" >
                <Option
                v-for="item in volunteerType"
                :value="item.dictKey"
                :key="item.dictKey"
                >{{ item.dictValue }}</Option>
              </Select>
        </FormItem>
     </Form>
  </div>
</template>

<script>
export default {
  props:{
    volunCheck:{
      type:Boolean,
      default:()=>{
        return false
      }
    },
    formDataVolun:{
      type:Object,
      default:()=>{
        return {}
      }
    },
    userId:{
            type:Object,
            default:()=>{
                return ''
            }
        },
  },
  data(){
    return{
      isCheck:false,
      volunteerType:[
        //  {dictKey:'1',dictValue:'定时性志愿者'},
        //  {dictKey:'2',dictValue:'临时性志愿者'},
      ]
    }
  },
  created(){
    this.getDicType('VOLUNTEER_TYPE','volunteerType')
    this.getDetail()
    if(this.volunCheck == true){
      this.isCheck = true
    }
  },
  methods:{ 
    changeCheck(val){
      this.isCheck = val
      this.$emit('changeVolun',val)
      // console.log(val);
    },
    getDetail(){
          if(this.userId && this.userId != ''){
            this.$get('/syaa/api/syuser/pc/residentArchive/selectArchiveVolunteer',{
              userId:this.userId,
              // familyId:this.familyId
            }).then(res=>{
              if(res.code == 200){
                  this.$emit('getVolunn',res.data)
              }else{
                this.$Message.error({
                  content:'志愿者信息获取失败',
                  background:true
                })
                return
              }
            })
          }
          
        },
         getDicType(type,model){
            this.$get('/voteapi/api/common/sys/findDictByDictType',{
                dictType:type
            }).then(res=>{
                this[model] = res.dataList
            })
        },
  },
   watch:{
     volunCheck:{
       hanlder(val,newVal){
         if(val){
           this.isCheck = val
         }
       }
     }
   }

}
</script>

<style lang="less" scoped>
.form-div{
    width:100%;
    user-select: none;
    .isForm{
        display: flex;
        flex-wrap: wrap;
        .isWidth{
        width: 40%;
        margin-right: 40px;
        }
        .isNoWidth{
            width: 100%;
        }
    }
    
}
/deep/.validate {
  &::before {
    content: "*";
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 14px;
    color: #ed4014;
  }
}
/deep/.ivu-date-picker{
    display: inline;
}
</style>